import React from "react";
import { Spinner } from "reactstrap";

function Loader({ color = "dark" }) {
  return (
    <>
      <Spinner color={color} />
    </>
  );
}

export default Loader;
